import React from 'react';
import glamorous, { Div } from 'glamorous';

import { media } from '../../../styles';

import { rules as rulesBody } from '../../typography/Body';
import { rules as rulesCaption } from '../../typography/Caption';

export const TableComponent = glamorous.div({
  display: 'flex',
  flexDirection: 'column',


  [media('sm', { isMax: true })]: {
    minWidth: '0 !important',
  },

  ...rulesBody,
});

export const TheadComponent = glamorous.div({
  display: 'none',
  flexDirection: 'column',

  [media('sm', { isMax: true })]: {
    minWidth: '0 !important',
  },

  [media('sm')]: {
    display: 'flex',
  },
}, ({ theme }) => ({
  borderBottom: `4px solid ${theme.default.lightest}`,
}));

const styleCaret = {
  width: 0,
  height: 0,
  borderLeft: '4px solid transparent',
  borderRight: '4px solid transparent',
};

const Caret = props => (<Div {...props} style={{ ...styleCaret, ...props.style }} />);

const CaretUp = props => (
  <Caret
    className="CaretUp"
    style={{
      marginBottom: 1,
      borderBottomStyle: 'solid',
      borderBottomWidth: 4,
    }}
  />
);

const CaretDown = props => (
  <Caret
    className="CaretDown"
    style={{
      marginTop: 1,
      borderTopStyle: 'solid',
      borderTopWidth: 4,
    }}
  />
);

const Th = glamorous.div({
  position: 'relative',
  display: 'flex',
  padding: '8px 16px',

  '&.ColumnDateTimeSmall': {
    display: 'none',
  },

  '& .CaretContainer': {
    display: 'none',
  },

  '&.-cursor-pointer': {
    cursor: 'pointer',
    userSelect: 'none',
  },

  '&.-cursor-pointer .CaretContainer': {
    display: 'flex',
  },

  '& .CaretUp': {
    borderBottomColor: 'rgba(0,0,0,0.11)',
  },

  '& .CaretDown': {
    borderTopColor: 'rgba(0,0,0,0.11)',
  },

  '&.-sort-asc .CaretUp': {
    borderBottomColor: 'rgba(0,0,0,0.54)',
  },
  '&.-sort-asc .CaretDown': {
    borderTopColor: 'rgba(0,0,0,0.11)',
  },

  '&.-sort-desc .CaretUp': {
    borderBottomColor: 'rgba(0,0,0,0.11)',
  },
  '&.-sort-desc .CaretDown': {
    borderTopColor: 'rgba(0,0,0,0.54)',
  },
});

const CaretContainer = glamorous.div({
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: -14,
  width: 14,
  height: '100%',
});

export const ThComponent = (props) => (
  <Th {...props} onClick={props.toggleSort}>
    <CaretContainer className="CaretContainer">
      <CaretUp />
      <CaretDown />
    </CaretContainer>
    {props.children}
  </Th>
);

export const ThRightComponent = glamorous.div({
  alignSelf: 'flex-end',
});

export const TbodyComponent = glamorous.div({
  [media('sm', { isMax: true })]: {
    minWidth: '0 !important',
  },
});

export const TrComponent = glamorous.div(props => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',

  cursor: props.onClick ? 'pointer' : undefined,

  [media('sm')]: {
    flexDirection: 'row',
  },
}));

export const TrGroupComponent = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  flex: '1 0 auto',

  '&:hover': {
    backgroundColor: '#ffffff',
  },
}, ({ theme, onClick }) => ({
  borderBottom: `1px solid ${theme.default.lightest}`,

  [media('sm', { isMax: true })]: {
    border: `1px solid ${theme.default.lightest}`,
    backgroundColor: '#ffffff',
    marginBottom: 8,
  },
}));

export const TdComponent = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 16px',
  minWidth: '100%',

  '&.CellTickets': {
    justifyContent: 'flex-end',
  },

  '&.CellDateTimeSmall': {
    display: 'none',
  },

  [media('sm', { isMax: true })]: {
    // paddingTop: 0,

    // '&:before': {
    //   content: 'attr(data-td-label)',
    //   marginBottom: 8,
    //   ...rulesCaption,
    //   fontWeight: 100,
    // },

    color: 'rgba(0,0,0,0.54)',

    // '&:first-child': {
    //   paddingTop: 16,
    // },

    '&.CellEvent': {
      color: 'inherit',
      paddingTop: 8,
      paddingBottom: 0,
      fontSize: '0.85em',
    },

    '&.CellVenue': {
      paddingTop: 0,
      paddingBottom: 8,
      fontSize: '0.8em',
    },

    '&.CellEvent, &.CellVenue': {
      // paddingRight: 192,
      paddingLeft: 64,
    },

    '&.CellDateTime, &.CellTickets': {
      justifyContent: 'flex-end',
      position: 'absolute',
      right: 0,
      minWidth: '0',
      width: 'auto !important',
      textAlign: 'right',
    },

    '&.CellDateTimeSmall': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      minWidth: 0,
      width: '56px !important',
      padding: 0,
      textAlign: 'center',
    },

    '&.CellDateTime': {
      display: 'none',
      top: 16,
    },

    '&.CellTickets': {
      display: 'none',
      // bottom: 0,
    },
  },

  [media('xs', { isMax: true })]: {
    '&.CellEvent, &.CellVenue': {
      paddingRight: 16,
    },

    '&.CellDateTime': {
      justifyContent: 'flex-end',
      position: 'static',
      minWidth: '100%',
      width: '100% !important',
      textAlign: 'left',
      paddingBottom: 16,
    },
  },

  [media('sm')]: {
    flexDirection: 'row',
    minWidth: '0',

    '&.CellDateTime': {
      justifyContent: 'flex-end',
      textAlign: 'right',
    },
  },
}, ({ theme }) => ({
  '&:before': {
    color: theme.default.light,
  },
}));



// WEBPACK FOOTER //
// ./src/components/ui/Table/TableComponents.js